// New color scheme theme for UpdateSubscription
const theme = {
  colors: {
    primary: '#ff914d',    // Orange
    secondary: '#000000',  // Black
    accent: '#ef4136',     // Red
    white: '#ffffff',
    lightGray: '#f5f5f5',
    gray: '#e0e0e0',
    darkGray: '#666666',
    textPrimary: '#000000',
    textSecondary: '#666666',
  }
};

export default theme;



// WEBPACK FOOTER //
// ./src/components/UpdateSubscription/theme.js